import { PuebloTabsPage } from './../pueblo-tabs/pueblo-tabs';
import { VariablesGlobales } from './../../providers/variables-globales';
import { Consultas } from './../../providers/consultas';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { Pueblo } from '../../models/pueblo.model';
import { BuscadorPage } from '../buscador/buscador';
import { CiudadZonasPage } from '../lista-zonas-ciudad/lista-zonas-ciudad';
/**
 * Generated class for the ListaPueblosPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-lista-pueblos',
  templateUrl: 'lista-pueblos.html',
  providers: [ Consultas ]
})
export class ListaPueblosPage {
  public pueblos:Array<Pueblo>;
  public loader: any;
  public puebloGeolocalizado: Pueblo;
  public idProvincia: number;
  public pueblosBack:Array<Pueblo> = new Array<Pueblo>();

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,
    public modalCtrl: ModalController) {
      this.idProvincia = this.navParams.get("idProvincia");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ListaPueblosPage');
  }

  goToZonas(){
    const modal = this.modalCtrl.create(CiudadZonasPage,{idProvincia: this.idProvincia});
    modal.present();
    modal.onDidDismiss((idZona)=>{
      this.pueblos = new Array<Pueblo>();
      this.pueblos = this.pueblos.concat(this.pueblosBack);
      if(idZona){
        this.pueblos = this.pueblos.filter(x=>x.id_ciudad_zona == idZona);
      }else{
        this.pueblos = this.pueblos.concat(this.pueblosBack);
      }
    })
  }

  ngOnInit(){
    this.pueblosBack = new Array<Pueblo>();
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
      if(!this.idProvincia){
        this.consultas.getPueblos().subscribe(x=>
          {

            this.pueblos = x;
            this.pueblosBack = this.pueblosBack.concat(this.pueblos);
            this.loader.dismiss();
          },error=>console.error()
          );
        }else{
          this.consultas.getPueblosProvincia(this.idProvincia).subscribe(x=>
            {
              this.pueblos = x;
              this.pueblosBack = this.pueblosBack.concat(this.pueblos);
              this.loader.dismiss();
            },error=>console.error()
            );
        }
    });
  }

  goToPuebloMenu(pueblo){
    this.navCtrl.push(PuebloTabsPage,{pueblo});
  }

}



// WEBPACK FOOTER //
// ./src/pages/lista-pueblos/lista-pueblos.ts